import { Paper } from '@mui/material';
import {
  NotificationTypeEnum,
  useNotification,
} from '@prismamedia/one-components';
import { GoogleLogin } from '@react-oauth/google';
import { FC, useEffect } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import logoPrisma from '../../assets/svg/logo-prisma-small.svg';
import logoOne from '../../assets/svg/one-web.svg';
import { paths } from '../../routing';
import { auth, loginWithAzureIdToken } from '../../utils/auth';
import {
  getAzureIdTokenFromRedirect,
  hasAzureOAuthReturn,
  isAzureLoginConfigured,
  startAzureLogin,
} from '../../utils/azureAuth';
import { AzureLoginButton } from './AzureLoginButton';
import { useStyles } from './styles';

export const LoginPage: FC<RouteComponentProps> = ({ history, location }) => {
  const classes = useStyles();
  const { pushNotification } = useNotification();
  const isAuthenticated = auth.isAuthenticated();

  useEffect(() => {
    if (auth.isAuthenticated()) {
      history.replace(paths.SUBJECT_LIST);
    }
  }, [isAuthenticated, history]);

  useEffect(() => {
    if (!hasAzureOAuthReturn()) {
      return;
    }

    const completeAzureLogin = async () => {
      try {
        const idToken = await getAzureIdTokenFromRedirect();
        if (!idToken) {
          throw new Error('Erreur de connexion');
        }
        const jwt = await loginWithAzureIdToken(idToken);
        if (!jwt) {
          throw new Error('Erreur de connexion');
        }
        history.replace(paths.SUBJECT_LIST);
      } catch {
        pushNotification({
          message: 'Erreur de connexion',
          type: NotificationTypeEnum.error,
        });
      }
    };

    void completeAzureLogin();
  }, [history, pushNotification]);

  if (isAuthenticated) {
    return <Redirect to={paths.SUBJECT_LIST} />;
  }

  const loginWithIdToken = async (idToken?: string) => {
    try {
      if (!idToken) {
        throw new Error('Erreur de connexion');
      }
      const jwt = await auth.login(idToken);
      if (!jwt) {
        throw new Error('Erreur de connexion');
      }

      const stateFrom = location.state as { from?: string } | undefined;
      history.push(stateFrom?.from || paths.SUBJECT_LIST);
    } catch {
      pushNotification({
        message: 'Erreur de connexion',
        type: NotificationTypeEnum.error,
      });
    }
  };

  const onAzureClick = async () => {
    try {
      await startAzureLogin();
    } catch {
      pushNotification({
        message: 'Erreur de connexion',
        type: NotificationTypeEnum.error,
      });
    }
  };

  return (
    <div className={classes.wrapperBackgroundImage}>
      <Paper className={classes.wrapperLogin}>
        <img src={logoPrisma} alt="Prisma Logo" width={206} />
        <img className={classes.svgIcon} src={logoOne} alt="One Logo" />
        <div className={classes.oneWrapper}>SUITE ONE</div>
        <div className={classes.providers}>
          <GoogleLogin
            onSuccess={(response) => loginWithIdToken(response.credential)}
            onError={() => {
              pushNotification({
                message: 'Erreur de connexion',
                type: NotificationTypeEnum.error,
              });
            }}
            width="280"
          />
          {isAzureLoginConfigured() && (
            <AzureLoginButton onClick={onAzureClick} />
          )}
        </div>
      </Paper>
    </div>
  );
};
